import { useEffect, useMemo, useState } from "react";
import { postAxios } from "../../util/apiCall";
import * as XLSX from "xlsx";
import axios from "axios";

export const useListVendor = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [menu, setMenu] = useState("list-vendor");
  const [listVendor, setListVendor] = useState();
  const [popUpNewVendor, setPopUpNewVendor] = useState(false);
  const [popUpEditVendor, setPopUpEditVendor] = useState(false);

  const [nameNewVendor, setNameNewVendor] = useState();
  const [tlpNewVendor, setTlpNewVendor] = useState();
  const [faxNewVendor, setFaxNewVendor] = useState();
  const [npwpNewVendor, setNpwpNewVendor] = useState();
  const [emailNewVendor, setEmailNewVendor] = useState();
  const [alamatNewVendor, setAlamatNewVendor] = useState();
  const [attnNewVendor, setAttnNewVendor] = useState();

  const [isDisabled, setIsDisabled] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);

  const [pickEdit, setPickEdit] = useState();

  const [popUpImportListVendor, setPopUpImportListVendor] = useState(false);

  const [file, setFile] = useState(null);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getVendor`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setListVendor,
      ""
    );
    setIsRefresh(false);
  }, [isRefresh]);

  const handleKirimNewVendor = () => {
    if (
      nameNewVendor &&
      tlpNewVendor &&
      faxNewVendor &&
      npwpNewVendor &&
      emailNewVendor &&
      alamatNewVendor
    ) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/addNewVendor`,
        {
          tim: dataUser.tim,
          name: nameNewVendor,
          tlp: tlpNewVendor,
          fax: faxNewVendor,
          npwp: npwpNewVendor,
          email: emailNewVendor,
          alamat: alamatNewVendor,
          attn: attnNewVendor,
        },
        dataUser.auth,
        "",
        ""
      );

      setTimeout(() => {
        setIsRefresh(true);
        setPopUpNewVendor(false);
        setAlamatNewVendor();
        setEmailNewVendor();
        setNpwpNewVendor();
        setFaxNewVendor();
        setTlpNewVendor();
        setNameNewVendor();
        setAttnNewVendor();
        setIsDisabled(false);
      }, 500);
    }
  };

  const handleKirimEdit = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/editVendor`,
      {
        tim: dataUser.tim,
        data: pickEdit,
      },
      dataUser.auth,
      "",
      ""
    );

    setTimeout(() => {
      setIsRefresh(true);
      setPickEdit();
      setIsDisabled(false);
      setPopUpEditVendor(false);
    }, 500);
  };

  const handleChangeEdit = (e) => {
    const { name, value } = e.target;

    if (name === "email") {
      setPickEdit((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else {
      setPickEdit((prev) => ({
        ...prev,
        [name]: value.toUpperCase(),
      }));
    }
  };

  const handleDelete = (id) => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/deleteVendor`,
      {
        tim: dataUser.tim,
        id: id,
      },
      dataUser.auth,
      "",
      ""
    );

    setTimeout(() => {
      setIsRefresh(true);
    }, 500);
  };

  const handleExportTemplate = async () => {
    try {
      const filteredDataExcel = [
        {
          name: "",
          tlp: "",
          fax: "",
          npwp: "",
          email: "",
          alamat: "",
          attn: "",
        },
      ];

      const workSheet = XLSX.utils.json_to_sheet(filteredDataExcel);

      workSheet["!cols"] = [
        { wch: 20 },
        { wch: 14 },
        { wch: 14 },
        { wch: 14 },
        { wch: 14 },
        { wch: 40 },
        { wch: 21 },
      ];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet");
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workBook, `Template Import List Vendor.xlsx`);
    } catch (error) {
      console.log(error);
    }
  };

  const handleBulkImportList = () => {
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/addNewListVendorBulk`,
          {
            tim: dataUser.tim,
            data: json,
          },
          {
            headers: {
              Authorization: `Bearer ${dataUser.auth}`,
            },
          }
        );
      };
      reader.readAsBinaryString(file);
      setTimeout(() => {
        setIsRefresh(true);
        setFile(null);
        setPopUpImportListVendor(false);
      }, 500);
    }
  };

  return {
    dataUser,
    menu,
    setMenu,
    listVendor,
    popUpNewVendor,
    setPopUpNewVendor,
    popUpEditVendor,
    setPopUpEditVendor,

    nameNewVendor,
    setNameNewVendor,
    tlpNewVendor,
    setTlpNewVendor,
    faxNewVendor,
    setFaxNewVendor,
    npwpNewVendor,
    setNpwpNewVendor,
    emailNewVendor,
    setEmailNewVendor,
    alamatNewVendor,
    setAlamatNewVendor,
    isDisabled,
    setIsDisabled,
    handleKirimNewVendor,
    pickEdit,
    setPickEdit,
    handleChangeEdit,
    handleKirimEdit,
    handleDelete,
    attnNewVendor,
    setAttnNewVendor,
    popUpImportListVendor,
    setPopUpImportListVendor,
    setFile,
    handleBulkImportList,
    handleExportTemplate,
  };
};
